import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Spinner } from '@/components/spinner';
import { useAppContext } from '@/context/app';
import { CreateMachineWizardStep1, SimpleUserGroup } from './Step1';
import { useWizard, WizardData, WizardProvider } from './context';
import { CreateMachineWizardStep2 } from './Step2';
import { UseFormReturn } from 'react-hook-form';
import { addServerErrors } from '@/components/forms/common/FormBase';
import { FormData, Machine, QuickCreateMachineForm } from './types'
import { CreateMachineWizardStep3 } from './Step3';

const maxStep = 3

export const CreateMachineWizardBody = ({ onDone }: {
  onDone: (id: string) => void
}) => {
  const {services, session, translates} = useAppContext()
  const { wizardData, updateWizardData, step, setStep } = useWizard()

  const handle = (data: WizardData, form: UseFormReturn<FormData, any, undefined>): Promise<void> => {
    // delete data.id
    return services.session.fetchWithToken(`/api/communal/machines/wizard/create`, {
      method: 'POST',
      body: JSON.stringify(data),
    }).then(async (r) => {
      if (r.status !== 200) {
        const erros = await r.json()
        translates && addServerErrors(form, translates, erros)
        return
      }
      const respData = await r.json()
      onDone(respData.machineId)
    })
  }

  if (step === 0) {
    return <CreateMachineWizardStep1  />
  } else if (step === 1) {
    return <CreateMachineWizardStep2 />
  } else if (step === 2) {
    return <CreateMachineWizardStep3 onDone={handle} />
  } else return <Spinner />
}

export const MachineCreateWizard = ({ qrCode, machine, onDone }: {
  qrCode?: string
  machine?: Machine | undefined
  onDone: (id: string) => void
}) => {
  return <div className='machine-create-wizard'>
    <WizardProvider initialQrCode={qrCode} initialMachine={machine} maxStep={maxStep}>
      <CreateMachineWizardBody onDone={onDone} />
    </WizardProvider>
  </div>
}

export const CreateMachineWizardPopup = ({ qrCode, machine, onClose }: {
  qrCode?: string
  machine?: Machine | undefined
  onClose: () => void
}) => {
  return <MachineCreateWizard qrCode={qrCode} machine={machine} onDone={onClose} />
}
